import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { JsonSchemaFormService } from 'angular4-json-schema-form-updated';
import { Subscription } from 'rxjs/Subscription';
import { Member } from '../../shared/interface/member.interface';
import { CacheService } from '../../shared/services/cache.service';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { environment } from '../../../environments/environment';
import { SchemaProperty } from '../enums/schema-property.enum';
import { Observable } from 'rxjs';
import { StatusCodes } from '../enums/status-code.enum';
import { DataShareService } from '../../shared/services/data.service';
import { Http } from '@angular/http';
import { PersonalMessageService } from '../services/personal-schema-form.service';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'custom-mask-widget',
    template: `
    <!-- [class]="options?.htmlClass || ''"-->
    <div [class.floatLabelContainer]="true">
      <label *ngIf="options?.title"
        [attr.for]="'control' + layoutNode?._id"
        [class]="options?.labelHtmlClass || ''"
        [style.display]="options?.notitle ? 'none' : ''"
        [innerHTML]="options?.title"></label>
      <input float-label
        [dropSpecialCharacters]="false" [mask]="options?.maskFormat"
        [formControl]="formControl"
        [attr.aria-describedby]="'control' + layoutNode?._id + 'Status'"
        [attr.list]="'control' + layoutNode?._id + 'Autocomplete'"
        [attr.maxlength]="options?.maxLength"
        [attr.minlength]="options?.minLength"
        [attr.pattern]="options?.pattern"
        [attr.placeholder]="options?.placeholder"
        [attr.required]="options?.required"
        [class]="options?.fieldHtmlClass || ''"
        [disabled]="controlDisabled"
        [id]="'control' + layoutNode?._id"
        [name]="controlName"
        [readonly]="options?.readonly ? 'readonly' : null"
        [type]="layoutNode?.type"
        [value]="controlValue"
        (input)="updateValue($event)"
        (blur)="validateInputValue($event)"
        (keydown)="onChange()"
        (paste)="onChange()"
        (keypress)="onChange();validationInProgress($event);removeError();"
        (keyup)="removeError()" (paste)="validationInProgress($event)">
        <span *ngIf="options?.hint" class="fa fa-question-circle-o mr-2 personal-info--bonus-info"
        [outsideClick]="true" containerClass="personal-info--bonus-info__popover" placement ="top"
            [popover]="controlName==schemaPropertyEnum.VATID ? hintTemplateVatId : hintTemplate" >
        </span>
        <ng-template #hintTemplateVatId>
          {{options?.hint}}
        </ng-template>
        <ng-template #hintTemplate>
            {{'allowed format(s) '}} <br> {{options?.hint}}
        </ng-template>
        <datalist *ngIf="options?.typeahead?.source"
          [id]="'control' + layoutNode?._id + 'Autocomplete'">
          <option *ngFor="let word of options?.typeahead?.source" [value]="word">
        </datalist>
        <!-- Email verification spinner block start -->
        <span *ngIf="layoutNode?.name==='email' && isShowLoader" tabindex="0" class="personal-info--email-info">
        <i class="fa fa-spinner"></i></span>
        <!-- Email verification spinner block end -->
        <!-- Government Id verification spinner block start -->
        <span *ngIf="layoutNode?.name==='vatId' && isShowVATIdLoader" tabindex="0" class="personal-info--email-info">
        <i class="fa fa-spinner"></i></span>
        <!-- Government Id verification spinner block end -->
    </div>
    <span *ngIf="customMessage" [class]="'error custom-error'">{{customMessage}}</span>`,
})
export class CustomMaskTextboxComponent implements OnInit {
    formControl: AbstractControl;
    controlName: string;
    controlValue: string;
    controlDisabled = false;
    boundControl = false;
    customMessage: any;
    options: any;
    selectSubscription: Subscription;
    optionsGetUrl: any;
    validateUrl: any;
    storeId: any;
    isoCountryCode: string;
    enrollCountryCode: string;
    autoCompleteList: string[] = [];
    userInfo: Member;
    isShowLoader = false;
    @Input() layoutNode: any;
    @Input() layoutIndex: number[];
    @Input() dataIndex: number[];
    isShowVATIdLoader: boolean;
    vatChangeSubscription: Subscription;
    schemaPropertyEnum = SchemaProperty;

    constructor(
        private jsf: JsonSchemaFormService, private _cacheService: CacheService,
        private _http: Http,
        private _dataService: DataShareService,
        private chRef: ChangeDetectorRef,
        private _personalMessageService: PersonalMessageService
    ) { }

    ngOnInit() {
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this.options = this.layoutNode.options || {};
        if (this.options) {
            this.jsf.initializeControl(this);
        }
        this.submitBonusInfoForm();
    }

    /**
     * @description This method used to submit bonus info form
     * @date 2019-09-30
     * @private
     * @memberof BonusInfoComponent
     */
    submitBonusInfoForm(): void {
        if (this.controlValue && this.controlName === SchemaProperty.VATID) {
            this.vatChangeSubscription = this._personalMessageService.getVatIdChanged().subscribe(isSubmit => {
                if (isSubmit && this.controlValue && this.controlName === SchemaProperty.VATID) {
                    this.getService(this.controlValue);
                }
            });
        }
    }

    /**
     * @returns void
     */
    removeError(): void {
        sessionStorage.removeItem('customError-' + this.controlName);
    }

    /**
     * @description set uppercase while on changing vatid
     * @date 2020-09-15
     * @memberof CustomMaskTextboxComponent
     */
    onChange() {
        if (this.controlValue && this.layoutNode.name === 'vatId') {
            this.controlValue = this.controlValue.toUpperCase();
        }
    }

    /**
     * @returns void
     */
    validationInProgress($event: any): void {
        sessionStorage.setItem('validationStatus-' + this.controlName, 'InProgress');
    }

    /**
     * @param  {any} event
     */
    updateValue(event: any) {
        this.jsf.updateValue(this, event.target.value);
    }

    /**
    * @param  {any} event
    */
   validateInputValue(event: any) {
        if (!this.options.readonly && this.options && this.options.optionGetUrl) {
            this.getService(event.target.value);
        }
    }


    /**
    * @returns void
    */
   getService(validateValue: any): void {
    const schemaProperty: any = this.jsf.schema.properties[this.controlName];
    if ((validateValue.trim()).length > 0 && this.formControl.valid) {
        const validateUrl: string = environment.apiUrl + schemaProperty.optionGetUrl;
        if (this.controlName === SchemaProperty.VATID) {
            validateValue = encodeURIComponent(validateValue.replace(/\s/g, ''));
            this.validateUrl = validateUrl + validateValue;
            this.isShowVATIdLoader = true;
            this._dataService.isVatIDValidating = this.isShowVATIdLoader;
        }
        this.customMessage = '';
        sessionStorage.setItem('validationStatus-' + this.controlName, 'InProgress');
        this.selectSubscription = this.validateUnique(this.validateUrl)
            .subscribe((response) => {
                sessionStorage.removeItem('validationStatus-' + this.controlName);
                if (this.controlName !== 'email') {
                    this.isShowVATIdLoader = false;
                    this._dataService.isVatIDValidating = this.isShowVATIdLoader;
                }
                if (response && response._body === 'false') {
                    schemaProperty.customErrorMessage = '';
                    schemaProperty.uniqueValidationMessage = '';
                    this.showCustomErrorMessage(schemaProperty);
                } else if (response && response._body === 'true') {
                    this.showCustomErrorMessage(schemaProperty);
                } else if (response) {
                    this.showCustomErrorMessage(schemaProperty);
                }
            }, (errResponse: any) => {
                this.isShowLoader = false;
                this.isShowVATIdLoader = false;
                this._dataService.isVatIDValidating = this.isShowVATIdLoader;
                sessionStorage.removeItem('validationStatus-' + this.controlName);
                if (errResponse.status === StatusCodes.NotFound
                    || errResponse.status === StatusCodes.InternalServerError) {
                    this.customMessage = '';
                    sessionStorage.setItem('customError-' + this.controlName, 'true');
                    this.jsf.updateValue(this, validateValue);
                }
                const response = errResponse;
                if (this.controlName === 'vatId' && response && response.validations
                    && !response.statusCode && response.validations.length > 0) {
                    schemaProperty.uniqueValidationMessage = response.validations[0].message;
                    this.showCustomErrorMessage(schemaProperty);
                }
            });
    }
}

/**
      * @returns Observable
      */
     validateUnique(optionUrl: string): Observable<any> {
        return this._http
            .get(optionUrl)
            .map((response: any) => response);
    }

    /**
     * @returns void
     */
    private showCustomErrorMessage(schemaProperty: any): void {
        if (schemaProperty) {
            schemaProperty.customErrorMessage = schemaProperty.uniqueValidationMessage;
            this.customMessage = schemaProperty.uniqueValidationMessage;
            sessionStorage.setItem('customError-' + this.controlName, schemaProperty.uniqueValidationMessage);
        }
        if (!this.chRef['destroyed']) {
            this.chRef.detectChanges();
        }
    }

    ngOnDestroy(): void {
        if (this.vatChangeSubscription) {
            this.vatChangeSubscription.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/widgets/custom-mask-textbox.widget.ts